
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.501 0c.494 0 .977.14 1.388.402l7.997 5.105c1.15.734 1.46 2.22.694 3.322-.184.262-.42.488-.694.664l-7.997 5.104c-1.15.734-2.703.437-3.469-.664A2.32 2.32 0 010 12.605V2.395C0 1.072 1.12 0 2.501 0z"}})])
          )
        }
      }
    